<c-card *transloco="let t">
    <c-card-body class="px-2">

        <c-row>
          <c-col md="12" lg="6">
            <h3>{{ t('Delete Workers') }}</h3>
            <p> {{ t('Use this form to find workers created between two dates and delete them from the system.') }}</p>
          </c-col>
          <c-col md="12" lg="6" class="text-end mb-2">

            <div class="btn-group mb-2 " role="group">
              <a href="https://okalone.zendesk.com/hc/en-gb/articles/35352880028049-Delete-Workers" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
            </div>

          </c-col>
        </c-row>

          <div class="card mb-2">
            <div class="card-header"data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
              <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Results') }}
            </div>
            <div class="show" id="collapseExample">
              <div class="card-body">

                <form cForm >
                  <div class="row mb-2 d-flex justify-content-center">
                    <div class="col-sm-6">
                      <c-input-group>
                        <span cInputGroupText><svg cIcon name="cil-calendar"></svg>&nbsp;&nbsp; {{ t('Dates') }}</span>
                        <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="selected" name="datetime"  class="form-control"/>
                      </c-input-group>
                    </div>
                  </div>
                  <div class="row d-flex justify-content-center mb-2">
                    <div class="col-sm-3 d-flex justify-content-end">
                      <button cButton class="btn btn-info text-white" type="submit"  (click)="updateFilter()">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Search') }}
                        </span>
                      </button>
                    </div>
                </div>

                </form>

              </div>
            </div>
          </div>




          <c-row *ngIf="workers && ids">
            <c-col>

                <div class="text-center" *ngIf="ids.length > 0">
                    <button type="button" class="btn btn-success m-3 text-white" (click)="deleteWorkers()">{{ t('Delete Selected Workers') }}</button>
                </div>

                <p>{{ t('Here are all the workers created in this time period. By default they will all be deleted. Click the button on their row to toggle the delete on/off.') }}</p>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ t('PIN') }}</th>
                    <th scope="col">{{ t('Worker') }}</th>
                    <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th>
                    <th scope="col">{{ t('Monitors') }}</th>
                    <th scope="col" *ngIf="this.okService.groups && this.okService.groups.length > 0">{{ t('Groups') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let worker of workers">
                      <td>

                        <button  class="me-1 btn btn-sm btn-light text-white" (click)="toggleDelete(worker.id)" *ngIf="!ids.includes(worker.id)">
                            {{ t('Ignore') }}
                        </button>

                        <button  class="me-1 btn btn-sm btn-danger text-white" (click)="toggleDelete(worker.id)" *ngIf="ids.includes(worker.id)">
                            {{ t('Delete') }}
                        </button>
                      </td>
                      <th scope="row">
                        <div>
                          <span class="badge bg-light text-dark fs-5">{{ u.formatWorkerPin(worker.pin) }}</span>
                        </div>
                      </th>
                      <td>
                        <span><b class="fs-5">{{worker.name}}</b></span>
                        <div class="small text-medium-emphasis">
                          <span>{{worker.created_at}}</span>
                        </div>
                      </td>
                      <td>
                        {{worker.email}}
                        <div class="small text-medium-emphasis">
                          <span>{{worker.phone}} <span *ngIf="worker.phone && worker.cell">/</span> {{worker.cell}}</span>
                        </div>
                      </td>
                      <th>
                        <div class="small text-medium-emphasis">
                          <ng-container *ngFor="let monitor_name of worker.monitor_names; let i = index">
                            <span class="pointer" routerLink="/mgmt/monitor/{{worker.monitors[i]}}">{{ monitor_name }}&nbsp;&nbsp;</span>
                          </ng-container>
                        </div>
                      </th>
                      <th *ngIf="this.okService.groups.length > 0">
                        <div class="small text-medium-emphasis">
                          <ng-container *ngFor="let group_name of worker.group_names; let i = index">
                            <span class="pointer" routerLink="/mgmt/group/{{worker.group_ids[i]}}">{{ group_name }}&nbsp;&nbsp;</span>
                          </ng-container>
                        </div>
                      </th>

                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

    </c-card-body>
  </c-card>

